/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_PrefixesInputs */

const en_settings_prefixes = /** @type {(inputs: Settings_PrefixesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Title prefixes`)
};

const he_settings_prefixes = /** @type {(inputs: Settings_PrefixesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`קידומות כותרת`)
};

/**
* | output |
* | --- |
* | "Title prefixes" |
*
* @param {Settings_PrefixesInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const settings_prefixes = /** @type {((inputs?: Settings_PrefixesInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_PrefixesInputs, { locale?: "en" | "he" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_prefixes(inputs)
	return he_settings_prefixes(inputs)
});